import { getRgObjectsOfType as l, RG_TYPE as g } from "@project-rouge/rg-core";
import { getLevelCount as i } from "../object-helpers/index3.js";
import { getLevelApartmentCategoryCounts as m } from "./index3.js";
const a = (e) => {
  const o = [], r = l(e, g.Building), n = i(r, !1);
  for (let t = 0; t < n; t++) {
    const s = m(e, t);
    o.push({ i: t, mix: s });
  }
  return o;
};
export {
  a as getLevelArrayApartmentCategoryCounts
};
//# sourceMappingURL=index5.js.map
